import { InspectorPanelSettingsFields } from "../../InspectorPanelSettingsFields"
import * as Icons from "@nova/component-icons"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { ButtonPrimary } from "@nova/component-btn"
import { selectImageColorFinderFlightById } from "features/entity-caching/flights/selectors"
import { openColorFinder } from "plugins/ColorFinder/V2/redux/slice"

export const InspectorPanelICFLayer = ({ id }: { id: string }) => {
    const dispatch = useAppDispatch()
    const flight = useAppSelector(selectImageColorFinderFlightById(id))
    if (!flight) return null
    const colorDataExists = flight.images.length > 0

    return (
        <>
            <InspectorPanelSettingsFields shouldShowTopBorder={false}>
                {colorDataExists && (
                    <ButtonPrimary
                        title="View Color Data"
                        RightIcon={Icons.ArrowRight}
                        className="mb-2"
                        onClick={() => {
                            dispatch(openColorFinder({ flightId: id }))
                        }}
                    />
                )}
            </InspectorPanelSettingsFields>
        </>
    )
}
